// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom Turing table styles based on Antd */

.ant-layout-content div.Paper.Table-Only{
  padding: 0;
  min-height: auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
}

.ant-table-wrapper{}

.ant-table{}

.ant-table-title{
  padding: 10px 24px;
  border-bottom: 2px solid #e8e8e8;
  border-radius: 0;
}

.ant-table table{}

.ant-table .ant-table-thead > tr > th {
  font-weight: 600;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
  background: #fff;
  padding: 16px 24px;
}

.ant-table .ant-table-tbody > tr > td {
  /*height: 48px;*/
  font-size: 14px;
  color: #212121;
  background: #fff;
  padding: 10px 7px 9px 24px; /* to get 48px row height like in Alejandro spec */
}

.ant-table .ant-table-tbody > tr > td:last-child {
  /*text-align: right;
  padding-right: 24px;*/
}

.ant-table .ant-table-tbody > tr:hover td {
  background: transparent !important;
}

/*.ant-table .ant-table-tbody > tr td .ant-btn .material-icons {
  color: #888888;
}*/

.ant-table .ant-table-tbody > tr td .material-icons {
  color: #888888;
}
.ant-table .ant-table-tbody > tr td .material-icons:not(:last-of-type) {
  margin-right: 24px;
}

.ant-table-footer{
  display: none;
  /*padding: 16px 24px;
  background: #F5F5F5;*/
}

/*
** TABE TAGs
*/

.ant-table .ant-tag.tag-default{
  padding: 4px 12px;
  color: #212121;
  font-size: 14px;
  text-align: center;
  background-color: #EEEEEE;
  border: none;
  border-radius: 50px;
}

/*
** PAGINATION
*/

.ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 0;
  width: 100%;
  padding: 16px 24px;
  background: #F5F5F5;
  text-align: right;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
}

.ant-table-wrapper .ant-pagination-item{
  display: none;
}

.ant-modal-content .ant-table-wrapper {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/Table/tables.css"],"names":[],"mappings":";AACA,6CAA6C;;AAE7C;EACE,UAAU;EACV,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,mBAAmB;;AAEnB,WAAW;;AAEX;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B,EAAE,kDAAkD;AAChF;;AAEA;EACE;uBACqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb;uBACqB;AACvB;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;CAEC;;AAED;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["\n/* Custom Turing table styles based on Antd */\n\n.ant-layout-content div.Paper.Table-Only{\n  padding: 0;\n  min-height: auto;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n}\n\n.ant-table-wrapper{}\n\n.ant-table{}\n\n.ant-table-title{\n  padding: 10px 24px;\n  border-bottom: 2px solid #e8e8e8;\n  border-radius: 0;\n}\n\n.ant-table table{}\n\n.ant-table .ant-table-thead > tr > th {\n  font-weight: 600;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.5);\n  text-align: left;\n  background: #fff;\n  padding: 16px 24px;\n}\n\n.ant-table .ant-table-tbody > tr > td {\n  /*height: 48px;*/\n  font-size: 14px;\n  color: #212121;\n  background: #fff;\n  padding: 10px 7px 9px 24px; /* to get 48px row height like in Alejandro spec */\n}\n\n.ant-table .ant-table-tbody > tr > td:last-child {\n  /*text-align: right;\n  padding-right: 24px;*/\n}\n\n.ant-table .ant-table-tbody > tr:hover td {\n  background: transparent !important;\n}\n\n/*.ant-table .ant-table-tbody > tr td .ant-btn .material-icons {\n  color: #888888;\n}*/\n\n.ant-table .ant-table-tbody > tr td .material-icons {\n  color: #888888;\n}\n.ant-table .ant-table-tbody > tr td .material-icons:not(:last-of-type) {\n  margin-right: 24px;\n}\n\n.ant-table-footer{\n  display: none;\n  /*padding: 16px 24px;\n  background: #F5F5F5;*/\n}\n\n/*\n** TABE TAGs\n*/\n\n.ant-table .ant-tag.tag-default{\n  padding: 4px 12px;\n  color: #212121;\n  font-size: 14px;\n  text-align: center;\n  background-color: #EEEEEE;\n  border: none;\n  border-radius: 50px;\n}\n\n/*\n** PAGINATION\n*/\n\n.ant-table-wrapper .ant-table-pagination.ant-pagination {\n  margin: 0;\n  width: 100%;\n  padding: 16px 24px;\n  background: #F5F5F5;\n  text-align: right;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n}\n\n.ant-table-wrapper .ant-pagination-item{\n  display: none;\n}\n\n.ant-modal-content .ant-table-wrapper {\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
